import axiosService from './axios.service';
import ResponseService from './response.service';

const list = async (
  _perPage,
  _page,
  _commonSearch,
  sortBy,
  investmentType,
  sortUsing,
  sortOrder,
  isDashboard = false,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'projects',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        commonSearch: _commonSearch,
        sortBy: sortBy,
        investmentType: investmentType,
        isDashboard: isDashboard,
        sortUsing: sortUsing,
        sortOrder: sortOrder,
      },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const details = async (_projectId, slug) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'projects/' + _projectId + '/' + slug,
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const userProjectAgreementStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'projects/user_project_agreement/status',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const purchaseConfirmationEmailRequest = async (payload) => {
  try {
    const axiosData = {
      method: 'post',
      url: 'contact-us/send-contact-us-email',
      isAuthorized: true,
      formData: payload,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const ProjectsService = {
  list,
  details,
  userProjectAgreementStatus,
  purchaseConfirmationEmailRequest,
};

export default ProjectsService;
